import React, {Component} from 'react'
import DocumentTitle from 'react-document-title'
import Banner from '../Banner'
import BannerContent from './BannerContent'
import Description from './Description'
import Features from './Features'
import Cards from './Cards'
import Whitepaper from './Whitepaper'
import Cta from '../Cta'

import style from './style.sass'

class Home extends Component {
  componentDidMount() {
    if (this.props.location.hash) {
      const section = document.querySelector(this.props.location.hash)
      if (section) {
        const offset = section.getBoundingClientRect().top
        window.scrollTo({top:offset})
      }
    }
  }
  render() {
    return(
      <div styleName='wrapper'>
        <DocumentTitle title='Algoriz'/>
        <Banner>
          <BannerContent/>
        </Banner>
        <Description/>
        <Features/>
        <Cards/>
        <Whitepaper/>
        <Cta/>
      </div>
    )
  }
}

export default Home
